import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const BVUService = {
  async getBanks({ page, perPage, filters }) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get('banks/', {
      params,
    });

    if (res.status === 200 && res.statusText === 'OK') {
      return res.data;
    }

    return Promise.reject();
  },

  async getAllBanks() {
    const res = await axios.get('getallbank/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async createBank(data) {
    const res = await axios.post('banks/', data);

    if (res.status === 201) {
      return true;
    }
    return Promise.reject();
  },

  async deleteBank(id) {
    const res = await axios.delete(`banks/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async updateBank(data, id) {
    const res = await axios.put(`banks/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
